

export const alkomprarTenant = {
  name: 'alkomprar',
  properties: {
    // Primary colors
    '--primary': '#e30513',
    '--secondary': '#004590',
    '--tertiary': '#e3e829',
    '--quarter': '#54555a',
    '--error': 'red',
    '--nav-bar': '#fff',

    /* Buttons */
    // Primary
    '--color-button-primary': '#fff',
    '--bg-color-button-primary': '#f1d900',
    '--hover-color-button-primary': '#fff',
    '--hover-bg-color-button-primary': '#dd2e32',
    // Secondary
    '--color-button-secondary': '#fff',
    '--bg-color-button-secondary': '#e30513',
    '--hover-color-button-secondary': '#fff',
    '--bg-hover-color-button-secondary': '#f1d900',
    // Tertiary
    '--color-button-tertiary': '#fff',
    '--bg-color-button-tertiary': '#f1d900',
    '--hover-color-button-tertiary': '#fff',
    '--bg-hover-color-button-tertiary': '#f1d900',

    // Forms
    '--color-input-valid': '#004c99',

    // Fonts
    '--primary-semibold-font-family': 'HelveticaNeueBold',
    '--font-family-secondary': `'Barlow', sans-serif`,
    '--font-family-secondary-medium': `'Barlow', sans-serif`,

    // Header
    '--background-header': '#fff',
    '--color-breadcrumb': '#e30513',
    '--color-breadcrumb-sucess': '#e30513',
    '--logo': 'url(../../../../assets/images/tenants/alkomprar/logo.png)',

    // Footer
    '--footer-color': '#fff',

    // SOAT
    '--color-tittle-h2': '#dd2e32',
    '--color-tittle-h3': '#dd2e32',
  }
};
